import React, { useEffect } from 'react'
import styles from './aboutus.module.css'
import { AboutAccordion, AboutBanner, AboutOffice, AboutOurClients, AboutTeam, Marque, MarqueBig, } from '../../components'
import { useDispatch, useSelector } from 'react-redux'
import { fetchHowWeDoData } from '../../slice/howWeDoSlice'
import { fetchOurTeamData } from '../../slice/teamSlice'
import { fetchOfficesData } from '../../slice/officeSlice'
import { fetchConfigData } from '../../slice/configSlice'
import { fetchClientData } from '../../slice/clientSlice'

const AboutUs = () => {

    const dispatch = useDispatch();
    /*  const {data : howWeDoData, loading, error} = useSelector((state) => state.howWeDo);
     const {data : teamData} = useSelector((state) => state.team); */

    const {
        howWeDo: { data: howWeDoData, loading, error },
        team: { data: teamData },
        office: { data: officeData },
        config: { data: configData },
        client : {data : clientData},
    } = useSelector((state) => state);

    useEffect(() => {
        dispatch(fetchHowWeDoData());
        dispatch(fetchOurTeamData());
        dispatch(fetchOfficesData());
        dispatch(fetchConfigData());
        dispatch(fetchClientData());
    }, [dispatch]);

    useEffect(() => {
        console.log(' How We Do It Data : ', howWeDoData);
        console.log('Team Data : ', teamData);
        console.log('Offices Data : ', officeData);
        console.log('Config Data : ', configData);
        console.log("Client Data : ", clientData);
    }, [howWeDoData, teamData, officeData, configData, clientData]);


    return (
        <section className={styles.aboutusSec}>
            <AboutBanner configData={configData} />
            <AboutTeam teamData={teamData} />
            {/* <MarqueBig /> */}
            <AboutAccordion howWeDoData={howWeDoData} />
            <AboutOurClients clientData = {clientData}/>

            {/* <AboutOffice officeData = {officeData} /> */}


            {/* <Marque /> */}
        </section>
    )
}

export default AboutUs
